/* src/app/modules/portal/components/landing-page/landingPage.component.scss */
:host {
  flex: 1 0;
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: "content  image";
  overflow-x: hidden;
}
sh-tool {
  --ui-1:
    0,
    0,
    0;
}
[content] {
  grid-area: content;
  display: flex;
  flex-direction: column;
  padding: 2rem;
}
[img] {
  background: url(/portal/assets/splash-screen.jpg);
  grid-area: image;
  background-size: cover;
  background-position: center;
  width: auto;
  height: auto;
  position: relative;
  box-shadow: var(--shadow-overlay);
}
[logo] {
  background: url(/portal/assets/logo.png);
  position: absolute;
  left: 1rem;
  top: 1rem;
  width: 98px;
  height: 34px;
}
[tabContents] {
  padding: 1rem;
  --sh-tool-width: 5rem;
  --sh-tool-height: var(--sh-tool-width);
  --ui-1:
    255,
    255,
    255;
  --opacity-7: 1;
  --opacity-6: 0.6;
}
[tabContents] a {
  text-decoration: none;
}
app-mi-applications {
  --sh-tool-width: 6rem !important;
  --sh-icon-font-size-m: 3rem;
}
app-hello-there {
  margin-bottom: 1rem;
}
sh-search {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
[screen-phone] :host-context [content] {
  padding: 1rem;
  justify-content: start;
}
[screen-phone] :host-context [img] {
  height: 180px;
}
[screen-tablet] :host-context [img] {
  height: 250px;
}
[screen-tablet] :host-context,
[screen-phone] :host-context {
  grid-template-rows: auto 1fr;
  grid-template-columns: 1fr;
  grid-template-areas: "image" "content";
}
sh-search {
  border-radius: 100rem;
  overflow: hidden;
}
/*# sourceMappingURL=landingPage.component.css.map */
